import { render, staticRenderFns } from "./IdentityVerification.vue?vue&type=template&id=ebc713f4&"
import script from "./IdentityVerification.vue?vue&type=script&lang=js&"
export * from "./IdentityVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports